/* ==========================================================================
   DOWN UNDER BRO — PHOTO LOOP (product photos on phones)
   --------------------------------------------------------------------------
   WHAT IT DOES
     On a phone, customers swipe left and right through a product's photos.
     Normally the swipe just stops at the last photo. With this file:
       • Swipe left on the LAST photo   → goes back to the FIRST photo.
       • Swipe right on the FIRST photo → goes round to the LAST photo.
     Every other swipe works exactly as before.

   WHERE IT WORKS
     Only the main product photo slider on product pages (the "media gallery").
     Other sliders on the site are left alone.

   HOW IT'S SWITCHED ON
     layout/theme.liquid loads this file (the last line before </body>).
     To turn it off, delete that one line.

   SETTINGS YOU CAN CHANGE
     MIN_SWIPE — how far (in pixels) a finger must move sideways before it
     counts as a swipe. Bigger number = harder to trigger by accident.
   ========================================================================== */

(function () {
  'use strict';

  /* ------------------------------------------------------------------------
     1. SETTINGS
     ------------------------------------------------------------------------ */
  const MIN_SWIPE = 40;

  /* ------------------------------------------------------------------------
     2. FIND THE PHOTO SLIDER
     Returns the product photo slider the finger touched, or nothing if the
     finger was somewhere else (or on a slider inside a pop-up window).
     ------------------------------------------------------------------------ */
  function findPhotoSlider(target) {
    if (!(target instanceof Element)) return null;

    const slider = target.closest('media-gallery slideshow-component');
    if (!slider || slider.closest('dialog')) return null;

    // The slider's own code must be loaded and set to loop.
    if (typeof slider.next !== 'function' || !slider.infinite || slider.disabled) return null;

    // Looping only makes sense with 2 or more photos.
    if (!slider.slides || slider.slides.length < 2) return null;

    return slider;
  }

  /* ------------------------------------------------------------------------
     3. FINGER DOWN
     Remember where the finger started and whether the customer was looking
     at the first or last photo at that moment.
     ------------------------------------------------------------------------ */
  let swipe = null;

  document.addEventListener(
    'touchstart',
    (event) => {
      swipe = null;
      if (event.touches.length !== 1) return; // two fingers = pinch-zoom, ignore

      const slider = findPhotoSlider(event.target);
      if (!slider) return;

      const touch = event.touches[0];
      swipe = {
        slider,
        startX: touch.clientX,
        startY: touch.clientY,
        onFirstPhoto: slider.atStart,
        onLastPhoto: slider.atEnd,
      };
    },
    { passive: true }
  );

  /* ------------------------------------------------------------------------
     4. FINGER UP
     If it was a clear sideways swipe "off the end", loop round.
     ------------------------------------------------------------------------ */
  document.addEventListener(
    'touchend',
    (event) => {
      if (!swipe) return;
      const { slider, startX, startY, onFirstPhoto, onLastPhoto } = swipe;
      swipe = null;

      const touch = event.changedTouches[0];
      if (!touch) return;

      const movedX = touch.clientX - startX; // negative = finger moved left
      const movedY = touch.clientY - startY;

      // Ignore short taps and mostly up/down movements (scrolling the page).
      if (Math.abs(movedX) < MIN_SWIPE) return;
      if (Math.abs(movedX) < Math.abs(movedY) * 1.5) return;

      if (movedX < 0 && onLastPhoto) {
        slider.next(); // last photo → first photo
      } else if (movedX > 0 && onFirstPhoto) {
        slider.previous(); // first photo → last photo
      }
    },
    { passive: true }
  );

  // The phone cancelled the touch (e.g. a call came in): forget it.
  document.addEventListener(
    'touchcancel',
    () => {
      swipe = null;
    },
    { passive: true }
  );
})();